export default function CsPasswords() {
  return (
    <h2>Cs Passwords</h2>
  );
}
